import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { useIsSuggestionFocused } from '../../../store/suggestions-nav';
import FocusedNavHeader from './focused-nav-header';
type SuggestionShellProps = {
  suggestionId?: string;
  children: ReactNode;
};
const SuggestionShell = t0 => {
  const $ = _c(10);
  const {
    suggestionId,
    children
  } = t0;
  const isFocused = useIsSuggestionFocused(suggestionId);
  const t1 = isFocused ? "border-accent shadow-focus-accent" : "border-accent/20";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("relative bg-primary border rounded-md px-3 py-2.5 flex flex-col gap-2 wrap-break-word md:wrap-normal", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isFocused || $[3] !== suggestionId) {
    t3 = isFocused && suggestionId && <FocusedNavHeader suggestionId={suggestionId} />;
    $[2] = isFocused;
    $[3] = suggestionId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== suggestionId || $[7] !== t2 || $[8] !== t3) {
    t4 = <div data-suggestion-id={suggestionId} className={t2}>{t3}{children}</div>;
    $[5] = children;
    $[6] = suggestionId;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default SuggestionShell;